<template>
  <div class="order-taiku">
    <!-- Banner图片 -->
    <div class="order-banner">
      <img class="order-banner-img" src="@/assets/img/多肽订购.png" alt="多肽订购主图" loading="eager" />
    </div>

    <!-- 快速询价 -->
    <div class="tk-section tk-inquiry">
      <div class="tk-intro-title">快速询价</div>
      <div class="tk-intro-sub">Quick Inquiry</div>
      <div class="inquiry-content">
        <p class="inquiry-desc">在确认序列或者结构、CAS号、纯度等前提下：</p>
        <p class="inquiry-desc">一般目录产品，24小时内发送，或直接联系官网客服进行询价，我们的销售人员将在30分钟内给与回复。</p>
        
        <div class="contact-methods">
          <el-row :gutter="30">
            <el-col :span="12">
              <div class="contact-method-item">
                <i class="el-icon-phone contact-method-icon"></i>
                <div class="contact-method-title">移动电话</div>
                <div class="contact-method-content">15002819872</div>
                <div class="contact-method-label">全国移动热线</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="contact-method-item">
                <i class="el-icon-message contact-method-icon"></i>
                <div class="contact-method-title">邮件询价</div>
                <div class="contact-method-content">15002819872@163.com</div>
                <div class="contact-method-label">24小时在线</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 订单确认下单 -->
    <div class="tk-section tk-order-process">
      <div class="tk-intro-title">订单确认下单</div>
      <div class="tk-intro-sub">Order Confirmation</div>
      <div class="process-steps">
        <!-- 桌面端：美观的流程展示 -->
        <div class="process-steps-desktop">
          <div class="process-flow">
            <div class="process-item" v-for="(item, index) in processList" :key="index">
              <div class="process-number">{{ index + 1 }}</div>
              <div class="process-content">
                <div class="process-title">{{ item.title }}</div>
                <div class="process-desc">{{ item.description }}</div>
              </div>
              <div class="process-arrow" v-if="index < processList.length - 1">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 移动端：垂直步骤条 -->
        <el-steps :active="3" finish-status="success" direction="vertical" class="process-steps-mobile">
          <el-step title="提交订单" description="确认序列、结构、CAS号、纯度等信息"></el-step>
          <el-step title="订单确认" description="签署正式合同，必要时签署保密协议"></el-step>
          <el-step title="生产流程" description="进入订单生产流程"></el-step>
          <el-step title="进度跟踪" description="每周一次向客户汇报进度"></el-step>
        </el-steps>
      </div>
      <div class="process-desc-wrapper">
        <p>收到订单后，销售人员进行订单信息确认，签署正式合同，必要时签署保密协议，然后进入订单生产流程。</p>
        <p>我们提供一对一专属客服，销售人员每周一次向客户汇报进度，进度可以按照客户要求定制，如需任何问题请随时联系。</p>
      </div>
    </div>

    <!-- 产品定制与售后 -->
    <div class="tk-section tk-custom-service">
      <div class="tk-intro-title">产品定制与售后</div>
      <div class="tk-intro-sub">Custom Service & After-sales</div>
      
      <el-row :gutter="30" class="service-row">
        <el-col :span="12">
          <el-card class="service-card">
            <div slot="header" class="service-card-header">
              <i class="el-icon-document"></i>
              <span>产品定制</span>
            </div>
            <div class="service-card-content">
              <p>多肽产品均为定制生产，按要求提供COA文件。</p>
              <p>目录产品为您提供详细的HPLC、MS、COA文件及相关数据，相关数据包括详细的纯度、合成的氨基酸序列、分子量、溶解性等，如需您需要，我们提供核磁、氨基酸分析、元素分析、水分测定以及其他相关分析检测。</p>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="service-card">
            <div slot="header" class="service-card-header">
              <i class="el-icon-service"></i>
              <span>售后承诺</span>
            </div>
            <div class="service-card-content">
              <p>客户在收到产品1-2周内可以进行投诉，我们将免费复测，如复测不合格则退货，1-3年内使用不合格的，我们会提供复测。</p>
              <p>产品免费保存3个月。客户在产品使用过程中有任何问题，我们的技术人员将为客户解答。</p>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 服务优势 -->
    <div class="tk-section tk-advantages">
      <div class="tk-intro-title">服务优势</div>
      <div class="tk-intro-sub">Service Advantages</div>
      <el-row :gutter="20" class="advantages-row">
        <el-col :span="6" v-for="item in advantagesList" :key="item.title">
          <div class="advantage-item">
            <i :class="item.icon" class="advantage-icon"></i>
            <div class="advantage-title">{{ item.title }}</div>
            <div class="advantage-desc">{{ item.desc }}</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 底部信息 -->
    <div class="tk-footer">
      <div>电话：15002819872&nbsp; 邮箱：15002819872@163.com&nbsp; 地址：江西省赣州市章贡区长征大道12号</div>
      <div>备案号: <a href="https://beian.miit.gov.cn/#/Integrated/index">赣ICP备2026004521号-1</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Order',
  data() {
    return {
      processList: [
        {
          title: '提交订单',
          description: '确认序列、结构、CAS号、纯度等信息'
        },
        {
          title: '订单确认',
          description: '签署正式合同，必要时签署保密协议'
        },
        {
          title: '生产流程',
          description: '进入订单生产流程'
        },
        {
          title: '进度跟踪',
          description: '每周一次向客户汇报进度'
        }
      ],
      advantagesList: [
        {
          icon: 'el-icon-collection',
          title: '全种类多肽',
          desc: '产品种类齐全，覆盖各种需求'
        },
        {
          icon: 'el-icon-time',
          title: '快速服务',
          desc: '目录产品24小时发货，询价30分钟回复'
        },
        {
          icon: 'el-icon-user-solid',
          title: '专业团队',
          desc: '技术人员随时解答客户问题'
        },
        {
          icon: 'el-icon-phone-outline',
          title: '24小时客服',
          desc: '24小时客服热线，高效沟通'
        }
      ]
    }
  }
}
</script>
<style scoped>
.order-taiku {
  background: #f5f7fa;
  min-height: 100vh;
}
.order-banner {
  margin-top: 8px;
  width: 100%;
  overflow: hidden;
}
.order-banner-img {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  display: block;
}
.tk-section {
  max-width: 1200px;
  margin: 30px auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 30px 30px 10px 30px;
}
.tk-intro-title {
  font-size: 28px;
  color: #0e3fa5;
  text-align: center;
  font-weight: bold;
  margin-bottom: 10px;
}
.tk-intro-sub {
  font-size: 18px;
  color: #888;
  text-align: center;
  margin-bottom: 20px;
}
.tk-inquiry {
  margin-top: 20px;
}
.inquiry-content {
  margin-top: 20px;
}
.inquiry-desc {
  color: #333;
  font-size: 16px;
  line-height: 1.8;
  text-align: center;
  margin: 15px 0;
}
.contact-methods {
  margin-top: 30px;
}
.contact-method-item {
  text-align: center;
  padding: 30px 20px;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  transition: all 0.3s;
}
.contact-method-item:hover {
  border-color: #0e3fa5;
  box-shadow: 0 4px 12px rgba(14, 63, 165, 0.15);
}
.contact-method-icon {
  font-size: 48px;
  color: #0e3fa5;
  margin-bottom: 15px;
}
.contact-method-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
}
.contact-method-content {
  font-size: 18px;
  color: #0e3fa5;
  font-weight: bold;
  margin-bottom: 8px;
}
.contact-method-label {
  font-size: 14px;
  color: #999;
}
.tk-order-process {
  margin-top: 30px;
}
.process-steps {
  margin: 40px 0;
}
.process-steps-desktop {
  width: 100%;
  display: none;
}
.process-flow {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 1100px;
  margin: 0 auto;
}
.process-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 0 1 200px;
  min-width: 180px;
}
.process-number {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0e3fa5 0%, #5a7edc 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0 4px 12px rgba(14, 63, 165, 0.3);
  margin-bottom: 15px;
  transition: transform 0.3s;
}
.process-item:hover .process-number {
  transform: scale(1.1);
}
.process-content {
  text-align: center;
  padding: 0 10px;
}
.process-title {
  font-size: 18px;
  font-weight: bold;
  color: #0e3fa5;
  margin-bottom: 8px;
}
.process-item .process-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.process-arrow {
  position: absolute;
  right: -40px;
  top: 25px;
  color: #0e3fa5;
  font-size: 28px;
  font-weight: bold;
  z-index: 1;
}
.process-item:last-child .process-arrow {
  display: none;
}
@media (max-width: 1024px) {
  .process-arrow {
    right: -20px;
    font-size: 20px;
  }
}
@media (min-width: 769px) {
  .process-steps-desktop {
    display: block;
  }
  .process-steps-mobile {
    display: none;
  }
}
.process-desc-wrapper {
  margin-top: 30px;
}
.process-desc-wrapper p {
  color: #333;
  font-size: 16px;
  line-height: 1.8;
  text-align: justify;
  margin: 15px 0;
}
.tk-custom-service {
  margin-top: 30px;
}
.service-row {
  margin-top: 30px;
}
.service-card {
  height: 100%;
  min-height: 280px;
}
.service-card-header {
  font-size: 20px;
  color: #0e3fa5;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
}
.service-card-header i {
  font-size: 24px;
}
.service-card-content {
  padding: 10px 0;
}
.service-card-content p {
  color: #333;
  font-size: 15px;
  line-height: 1.8;
  text-align: justify;
  margin: 12px 0;
}
.tk-advantages {
  margin-top: 30px;
}
.advantages-row {
  margin-top: 30px;
}
.advantage-item {
  text-align: center;
  padding: 25px 15px;
  transition: transform 0.3s;
}
.advantage-item:hover {
  transform: translateY(-5px);
}
.advantage-icon {
  font-size: 48px;
  color: #0e3fa5;
  margin-bottom: 15px;
}
.advantage-title {
  font-size: 18px;
  color: #0e3fa5;
  font-weight: bold;
  margin-bottom: 10px;
}
.advantage-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}
.tk-footer {
  background: #2f2f2f;
  color: #fff;
  text-align: center;
  padding: 30px 0 10px 0;
  margin-top: 40px;
}
.tk-footer div {
  margin: 5px 0;
  font-size: 14px;
}
.tk-footer a {
  color: #fff;
  text-decoration: none;
}
@media (max-width: 768px) {
  .order-banner-img {
    max-height: 250px;
    object-fit: contain;
  }
  .tk-section {
    margin: 15px 8px;
    padding: 20px 15px;
  }
  .tk-intro-title {
    font-size: 22px;
  }
  .tk-intro-sub {
    font-size: 14px;
    margin-bottom: 15px;
  }
  .inquiry-desc {
    font-size: 14px;
    text-align: left;
    padding: 0 5px;
  }
  .contact-methods {
    margin-top: 20px;
  }
  .contact-method-item {
    padding: 20px 15px;
    margin-bottom: 15px;
  }
  .contact-method-icon {
    font-size: 36px;
  }
  .contact-method-title {
    font-size: 18px;
  }
  .contact-method-content {
    font-size: 14px;
    word-break: break-all;
  }
  .contact-method-label {
    font-size: 12px;
  }
  .process-steps {
    margin: 20px 0;
  }
  .process-steps-desktop {
    display: none !important;
  }
  .process-steps-mobile {
    display: block !important;
    padding-left: 10px;
  }
  .process-desc {
    margin-top: 20px;
  }
  .process-desc p {
    font-size: 14px;
    text-align: left;
    padding: 0 5px;
  }
  .service-row {
    margin-top: 20px;
  }
  .service-card {
    min-height: auto;
    margin-bottom: 15px;
  }
  .service-card-header {
    font-size: 16px;
    gap: 8px;
  }
  .service-card-header i {
    font-size: 20px;
  }
  .service-card-content {
    padding: 5px 0;
  }
  .service-card-content p {
    font-size: 14px;
    text-align: left;
    margin: 10px 0;
  }
  .tk-advantages {
    margin-top: 20px;
  }
  .advantages-row {
    margin-top: 15px;
  }
  .advantage-item {
    padding: 20px 10px;
    margin-bottom: 15px;
  }
  .advantage-icon {
    font-size: 36px;
  }
  .advantage-title {
    font-size: 16px;
  }
  .advantage-desc {
    font-size: 13px;
  }
  .tk-footer {
    padding: 20px 10px 10px 10px;
    margin-top: 20px;
    font-size: 12px;
    line-height: 1.6;
  }
  .tk-footer div {
    word-break: break-all;
    padding: 0 5px;
  }
  /* 响应式 el-row/el-col 卡片区块 */
  .el-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .el-col {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 8px 4px !important;
  }
  .el-col > div, .el-card {
    width: 100% !important;
    box-sizing: border-box;
  }
}

@media (min-width: 769px) {
  .process-steps-desktop {
    display: block !important;
  }
  .process-steps-mobile {
    display: none !important;
  }
}
</style>


